import React from "react";
import feedback from "./img/feedback.png";
import "./css/Feedback.css";

function Feedback() {
  return (
    <div className="feedback">
      <div className="feedback-container">
        <div className="feedback-container-img">
          <img src={feedback} alt="feedback" />
        </div>
        <div className="feedback-container-content">
          <div className="feedback-container-input">
            <p>Send us feedback</p>
            <input placeholder="Your name" />
            <input placeholder="Your email" />
            <textarea placeholder="Your message..." />
            <button>Send</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Feedback;
